import React from 'react';
import type { BankCostConfig } from '../../types';

interface Props {
  config: BankCostConfig;
  onChange: (config: BankCostConfig) => void;
}

export function BankCostPanel({ config, onChange }: Props) {
  const update = (field: keyof BankCostConfig, value: boolean | number) => {
    onChange({ ...config, [field]: value });
  };

  return (
    <div>
      <div className="flex items-center gap-3 mb-3">
        <h3 className="text-lg font-medium text-gray-900">Bank Costs</h3>
        <label className="relative inline-flex items-center cursor-pointer">
          <input
            type="checkbox"
            checked={config.enabled}
            onChange={(e) => update('enabled', e.target.checked)}
            className="sr-only peer"
          />
          <div className="w-9 h-5 bg-gray-200 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-indigo-500 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-indigo-600" />
          <span className="ms-2 text-sm text-gray-600">
            {config.enabled ? 'Enabled' : 'Disabled'}
          </span>
        </label>
      </div>

      {config.enabled && (
        <div className="grid grid-cols-2 gap-3 sm:gap-4 border border-gray-200 rounded-lg p-3 sm:p-4">
          <div>
            <p className="text-xs font-medium text-gray-500 mb-2 uppercase tracking-wide">
              Payment Bank Cost
            </p>
            <div className="space-y-2">
              <div>
                <label className="block text-xs text-gray-500">Fixed Fee ($)</label>
                <input
                  type="number"
                  step="0.01"
                  min="0"
                  value={config.paymentFixedFee}
                  onChange={(e) => update('paymentFixedFee', e.target.value === '' ? 0 : parseFloat(e.target.value))}
                  className="mt-0.5 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 text-sm"
                />
              </div>
              <div>
                <label className="block text-xs text-gray-500">Rate (%)</label>
                <input
                  type="number"
                  step="0.01"
                  min="0"
                  value={config.paymentRatePercent}
                  onChange={(e) => update('paymentRatePercent', e.target.value === '' ? 0 : parseFloat(e.target.value))}
                  className="mt-0.5 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 text-sm"
                />
              </div>
            </div>
          </div>
          <div>
            <p className="text-xs font-medium text-gray-500 mb-2 uppercase tracking-wide">
              Payout Bank Cost
            </p>
            <div className="space-y-2">
              <div>
                <label className="block text-xs text-gray-500">Fixed Fee ($)</label>
                <input
                  type="number"
                  step="0.01"
                  min="0"
                  value={config.payoutFixedFee}
                  onChange={(e) => update('payoutFixedFee', e.target.value === '' ? 0 : parseFloat(e.target.value))}
                  className="mt-0.5 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 text-sm"
                />
              </div>
              <div>
                <label className="block text-xs text-gray-500">Rate (%)</label>
                <input
                  type="number"
                  step="0.01"
                  min="0"
                  value={config.payoutRatePercent}
                  onChange={(e) => update('payoutRatePercent', e.target.value === '' ? 0 : parseFloat(e.target.value))}
                  className="mt-0.5 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 text-sm"
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
